<template>
	<div>
		<page-title-bar class="pb-1">
			<template slot="actions">
				<menu-downloads v-if="permisos.descargar"></menu-downloads>
			</template>
		</page-title-bar>
		<v-container fluid pt-0>
			<v-layout row wrap border-rad-sm overflow-hidden>
				<app-card
						colClasses="xs12"
						customClasses="mb-0"
						:fullScreen="true"
						:reloadable="true"
						:closeable="true"
						:fullBlock="true"
						:footer="false"
				>
					<data-table
							ref="tableEntregas"
							v-model="dataTable"
							@resetOption="item => resetOptions(item)"
							@anular="item => openDialogCancel(item)"
							@reportar="item => openDialogReporte(item)"
              @descargarSoporte="item => descargarSoporte(item)"
					></data-table>
				</app-card>
			</v-layout>
		</v-container>
		<confirmation-dialog
				ref="dialogCancel"
				color="error"
				heading="¿Seguro de continuar?"
				:message="`¿Está seguro de anular la entrega No. <strong>${selectedEntrega ? selectedEntrega.id : ''}</strong>?`"
				@onConfirm="cancelEntrega"
				@onCancel="selectedEntrega = null"
		>
		</confirmation-dialog>
		<detail-technologi-dialog ref="dialogInfoTechnologi" @onProcess="processingTable = false"></detail-technologi-dialog>
		<reporte-entrega-dialog
				ref="dialogReporteEntrega"
				:heading="`Reporte de <strong>${selectedEntrega && selectedEntrega.CausaNoEntrega ? 'no ' : ''}entrega</strong> No. <strong> ${selectedEntrega ? selectedEntrega.id : ''} </strong>`"
		>
		</reporte-entrega-dialog>
	</div>
</template>

<script>
    var $this = null
    export default {
        components: {
            ReporteEntregaDialog: () => import('@/components/Entregas/ReporteEntregaDialog'),
            MenuDownloads: () => import('@/components/Entregas/MenuDownloads')
        },
        data: () => ({
            processingTable: false,
            selectedEntrega: null,
            dataTable: {
                nameItemState: 'tableEntregas',
                route: 'entregas',
                makeHeaders: [
                    {
                        text: 'ID',
                        align: 'left',
                        sortable: false,
                        visibleColumn: false,
                        value: 'direccionamiento_id'
                    },
                    {
                        text: 'Id entrega',
                        align: 'left',
                        sortable: false,
                        value: 'id'
                    },
                    {
                        text: 'Tipo',
                        align: 'left',
                        sortable: false,
                        value: 'CausaNoEntrega',
                        component: {
                            render: function (createElement) {
                                return createElement(
                                    `span`,
                                    `${this.value.CausaNoEntrega ? 'No entrega' : 'Entrega'}`
                                )
                            },
                            props: ['value']
                        }
                    },
                    {
                        text: 'Prescripción',
                        align: 'left',
                        sortable: true,
                        value: 'NoPrescripcion'
                    },
					{
						text: 'Municipio Ent.',
						tooltip: 'Municipio de Entrega',
						align: 'left',
						sortable: false,
						value: 'CodMunEnt'
					},
                    {
                        text: 'ServTecEntregar',
                        tooltip: 'Servicio o tecnología a entregar',
                        align: 'center',
                        sortable: false,
                        value: 'CodSerTecAEntregar',
                        classData: 'text-xs-center',
                        component: {
                            render: function (createElement) {
                                if  (this.value.CodSerTecAEntregar) {
                                    return createElement(
                                        `a`,
                                        {
                                            domProps: {
                                                innerHTML: `${this.value.TipoTec} ${this.value.CodSerTecAEntregar}`
                                            },
                                            on: {
                                                click: () => {
                                                    $this.getDetalleTechnologi(this.value.TipoTec, this.value.CodSerTecAEntregar)
                                                }
                                            }
                                        }
                                    )
								} else {
                                    return createElement(
                                        `span`,
                                        {
                                            domProps: {
                                                innerHTML: ``
                                            }
                                        }
                                    )
								}
                            },
                            props: ['value']
                        }
                    },
                    {
                        text: 'ServTecEntregado',
                        tooltip: 'Servicio o tecnología entregada',
                        align: 'center',
                        sortable: false,
                        value: 'CodSerTecEntregado',
                        classData: 'text-xs-center',
                        component: {
                            render: function (createElement) {
                                if  (this.value.CodSerTecEntregado) {
                                    return createElement(
                                        `a`,
                                        {
                                            domProps: {
                                                innerHTML: `${this.value.TipoTec} ${this.value.CodSerTecEntregado}`
                                            },
                                            on: {
                                                click: () => {
                                                    $this.getDetalleTechnologi(this.value.TipoTec, this.value.CodSerTecEntregado)
                                                }
                                            }
                                        }
                                    )
                                } else {
                                    return createElement(
                                        `span`,
                                        {
                                            domProps: {
                                                innerHTML: ``
                                            }
                                        }
                                    )
                                }
                            },
                            props: ['value']
                        }
                    },
                    {
                        text: 'A entregar',
                        tooltip: 'Cantidad a entregar',
                        align: 'center',
                        sortable: false,
                        value: 'CantTotAEntregar',
                        classData: 'text-xs-center'
                    },
                    {
                        text: 'Entregada',
                        tooltip: 'Cantidad entregada',
                        align: 'center',
                        sortable: false,
                        value: 'CantTotEntregada',
                        classData: 'text-xs-center',
                        component: {
                            render: function (createElement) {
                                return createElement(
                                    `div`,
                                    {
                                        domProps: {
                                            innerHTML: `<span class="${this.value.CausaNoEntrega ? 'error--text' : ''}">${this.value.CantTotEntregada}</span>`
                                        }
                                    }
                                )
                            },
                            props: ['value']
                        }
                    },
                    {
                        text: 'Fecha entrega',
                        align: 'left',
                        sortable: false,
                        value: 'FecEntrega',
                        component: {
                            render: function (createElement) {
                                return createElement(
                                    `span`,
                                    `${this.value.FecEntrega ? this.moment(this.value.FecEntrega).format('YYYY-MM-DD HH:mm') : ''}`
                                )
                            },
                            props: ['value']
                        }
                    },
                    {
                        text: 'Paciente',
                        align: 'left',
                        sortable: false,
                        value: 'NoIDPaciente',
                        component: {
                            render: function (createElement) {
                                return createElement(
                                    `span`,
                                    `${this.value.TipoIDPaciente}${this.value.NoIDPaciente}`
                                )
                            },
                            props: ['value']
                        }
                    },
                  {
                    text: 'Usuario',
                    tooltip: 'Usuario que registra el último movimiento',
                    align: 'left',
                    sortable: false,
                    visibleColumn: false,
                    value: 'user_id',
                    component: {
                      render: function (createElement) {
                        return createElement(
                            `div`,
                            {
                              domProps: {
                                innerHTML: `
                                  <v-list-tile>
                                    <v-list-tile-content style="display: grid !important;">
                                      <v-list-tile-title class="body-2">${this.value.usuario ? this.value.usuario.name : ''}</v-list-tile-title>
                                      <v-list-tile-sub-title class="caption">${this.value.usuario ? this.value.usuario.email : ''}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                `
                              }
                            }
                        )
                      },
                      props: ['value']
                    }
                  },
                    {
                        text: 'Opciones',
                        align: 'center',
                        sortable: false,
                        actions: true,
                        singlesActions: true,
                        classData: 'text-xs-center'
                    }
                ],
                filters: []
            }
        }),
        computed: {
            permisos () {
                return this.$store.getters.getPermissionModule('entregas')
            }
        },
		created () {
            $this = this
		},
		methods: {
            openDialogReporte (item) {
                this.selectedEntrega = item
                this.$refs.dialogReporteEntrega.open(item)
			},
            getDetalleTechnologi (type, code) {
                this.processingTable = true
                this.$refs.dialogInfoTechnologi.getDetail(type, code)
            },
            cancelEntrega () {
                this.$refs.dialogCancel.loading()
                this.axios.delete(`entregas/${this.selectedEntrega.id}`)
                    .then(response => {
                        this.$refs.tableEntregas.reloadPage()
                        this.$store.commit('snackbar', {color: 'success', message: `Se anuló la entrega No. ${this.selectedEntrega.id} de forma correcta`})
                        this.$refs.dialogCancel.close()
                    }).catch(e => {
                    this.$refs.dialogCancel.loading(false)
                    this.$store.commit('snackbar', {color: 'error', message: `al tratar de anular la entrega No. ${this.selectedEntrega.id}`, error: e})
                })
			},
            openDialogCancel (item) {
                this.selectedEntrega = item
                this.$refs.dialogCancel.open()
			},
      async descargarSoporte (item) {
        item.loading = true
        let archivo = {
          url: `direccionamientos/soporte/${item.direccionamiento_id}`
        }
        await this.descargarArchivo(archivo)
        item.loading = false
      },
            resetOptions (item) {
                item.options = []
                if (item.EstEntrega === 1) item.options.push({event: this.permisos.reportar ? 'reportar' : '', icon: 'ti ti-export', tooltip: this.permisos.reportar ? 'Reportar' : 'Sin permisos para reportar', color: this.permisos.reportar ? 'info' : 'grey', size: 'medium'})
              item.options.push({event: this.generarSoporte ? 'descargarSoporte' : '', icon: 'zmdi zmdi-collection-pdf', tooltip: this.generarSoporte ? 'Descargar Soporte' : 'Sin permisos para descargar el soporte', color: this.generarSoporte ? 'black' : 'grey', size: 'medium'})
                if (item.EstEntrega === 1) item.options.push({event: this.permisos.anular ? 'anular' : '', icon: 'ti ti-trash', tooltip: this.permisos.anular ? 'Anular' : 'Sin permisos para anular', color: this.permisos.anular ? 'error' : 'grey', size: 'medium'})
                return item
            }
		}
    }
</script>